import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NWMCharts } from 'app/components/NWMCharts/NWMCharts.module';
import { PgfComponent } from './pgf.component';
import { PgfGrantsComponent } from './grants/grants.component';
import { PgfImapctsComponent} from "app/modules/pgf/impacts/impacts.component";
import { PgfImpactComponent} from "app/modules/pgf/impact/impact.component";
import { PgfAllNewsComponent } from './all-news/all-news.component';
import { PgfActivitiesComponent } from './activities/activities.component';
import { PgfCharityComponent } from './charity/charity.component';
import { PgfYearActivityComponent } from './year-activity/year-activity.component';
import { NWMControls } from 'app/components/Controls/NWMControls.module';
import { SharedModule } from "app/modules/shared/shared.module";

@NgModule({
    imports: [
        NWMControls,
        NWMCharts,
        RouterModule,
        SharedModule.forRoot(),
        PgfComponent,
        PgfActivitiesComponent,
        PgfCharityComponent,
        PgfYearActivityComponent,
        PgfGrantsComponent,
        PgfImapctsComponent,
        PgfImpactComponent,
        PgfAllNewsComponent,
    ],
    providers: []
})
export class PgfModule { }
